"use client";

import "../../styles/DMQCustomCard.css";

const ProgressDots = ({ total, active }) => {
  return (
    <div className="progress-dots">
      {Array.from({ length: total }).map((_, index) => (
        <div key={index} className={`progress-dot ${index === active - 1 ? "active" : ""}`} />
      ))}
    </div>
  );
};

const DMQCustomCard = ({ title, subtitle, pageHeader, children, totalDots = 0, activeDot = 0 }) => {
  return (
    <div className="custom-card">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="card-header">{title}</div>

          <ProgressDots total={totalDots} active={activeDot} />
        </div>
      </div>

      <div className="custom-card-subtitle">{subtitle}</div>
      {pageHeader && <div className="custom-card-title">{pageHeader}</div>}
      <div className="custom-card-body">{children}</div>
    </div>
  );
};

export default DMQCustomCard;
